import { NgModule } from '@angular/core';
import { Routes, RouterModule, mapToCanActivate, mapToCanDeactivate } from '@angular/router';
import { LunaClaimValues, LunaClaimTypes } from '../models/user-identity.model';
import { Claim } from "../admin/models/claim.model";
import { MasterGuardService } from "../auth/guards/master-guard.service";
import { CanDeactivateGuardService } from "../auth/guards/can-deactivate-guard.service";
import { GuardList } from "../auth/guards/guard-list.enum";
import { ReviewIssueComponent } from "./components/review-issue/review-issue.component";
import { IssuesSearchComponent } from "./components/issues-search/issues-search.component";
import { CreateIssueComponent } from "./components/create-issue/create-issue.component";
import { ComplianceApplicationResolver } from "./resolvers/compliance-application.resolver";
import { ViewIssuesComponent } from "./components/view-issues/view-issues.component";
import { ViewMyIssuesComponent } from './components/view-my-issues/view-my-issues.component';
import { ComplianceSubmissionsComponent } from './components/compliance-submissions/compliance-submissions.component';
import { ComplianceSubmissionsReviewComponent } from './components/compliance-submissions-review/compliance-submissions-review.component';
import { onBaseDocumentTypesByProcessResolver } from "../common/resolvers/onBaseDocumentTypesByProcess.resolver";
import { OnBaseProcessName } from "../common/models/onBaseIntegrationAndMapping.model";




export const ISSUES_ROUTES: Routes = [
    {
        path: "report-compliance",
        component: ComplianceSubmissionsComponent,
        canActivate: mapToCanActivate([MasterGuardService]),
        data: {
            guards: [ GuardList.BaseGuardService, GuardList.SystemPermissionGuardService ],
            permission: LunaClaimValues.SubmitComplianceReport
        },
        resolve: {
            documentTypes: onBaseDocumentTypesByProcessResolver(OnBaseProcessName.PostDrilling)
        },
        canDeactivate: mapToCanDeactivate([ CanDeactivateGuardService ])
    },
    {
        path: "review-issue/:id",
        component: ReviewIssueComponent,
        canActivate: mapToCanActivate([MasterGuardService]),
        data: {
            guards: [GuardList.InternalGuardService, GuardList.SystemPermissionGuardService],
            permission: LunaClaimValues.ManageIssues
        },
        canDeactivate: mapToCanDeactivate([ CanDeactivateGuardService ])
    },
    {
        path: ":id/review",
        component: ComplianceSubmissionsReviewComponent,
        canActivate: mapToCanActivate([MasterGuardService]),
        data: {
            guards: [GuardList.BaseGuardService, GuardList.SystemPermissionGuardService],
            permission: LunaClaimValues.ReviewComplianceReport
        },
        resolve: {
            application: ComplianceApplicationResolver,
            documentTypes: onBaseDocumentTypesByProcessResolver(OnBaseProcessName.PostDrilling)
        },
        canDeactivate: mapToCanDeactivate([ CanDeactivateGuardService ])
    },
    {
        path: ":id/resume",
        component: ComplianceSubmissionsComponent,
        canActivate: mapToCanActivate([MasterGuardService]),
        data: {
            guards: [GuardList.BaseGuardService, GuardList.SystemPermissionGuardService],
            permission: LunaClaimValues.SubmitComplianceReport
        },
        resolve: {
            documentTypes: onBaseDocumentTypesByProcessResolver(OnBaseProcessName.PostDrilling)
        },
        canDeactivate: mapToCanDeactivate([ CanDeactivateGuardService ])
    },
    {
        path: "approve-escalation/:id",
        component: ReviewIssueComponent,
        canActivate: mapToCanActivate([MasterGuardService]),
        data: {
            guards: [GuardList.InternalGuardService, GuardList.SystemPermissionGuardService],
            permission: LunaClaimValues.ApproveIssueEscalation
        },
        canDeactivate: mapToCanDeactivate([ CanDeactivateGuardService ])
    },
    {
        path: "search",
        component: IssuesSearchComponent,
        canActivate: mapToCanActivate([MasterGuardService]),
        data: {
            guards: [GuardList.InternalGuardService, GuardList.SystemPermissionGuardService],
            permission: LunaClaimValues.ManageIssues
        }
    },
    {
        path: "create-new",
        component: CreateIssueComponent,
        canActivate: mapToCanActivate([MasterGuardService]),
        data: {
            guards: [GuardList.InternalGuardService, GuardList.SystemPermissionGuardService],
            permission: LunaClaimValues.ManageIssues
        },
        canDeactivate: mapToCanDeactivate([ CanDeactivateGuardService ])
    },
    {
        path: "view-issues",
        component: ViewIssuesComponent,
        canActivate: mapToCanActivate([MasterGuardService]),
        data: {
            guards: [GuardList.InternalGuardService, GuardList.SystemPermissionGuardService],
            claims: [{ type: LunaClaimTypes.Widget, value: LunaClaimValues.ViewIssuesWidget } as Claim]
        }
    },
    {
        path: "view-my-issues",
        component: ViewMyIssuesComponent,
        canActivate: mapToCanActivate([MasterGuardService]),
        data: {
            guards: [GuardList.BaseGuardService, GuardList.SystemPermissionGuardService],
            claims: [{ type: LunaClaimTypes.Widget, value: LunaClaimValues.ViewExternalIssuesWidget } as Claim]
        }
    }
];

@NgModule({
    imports: [RouterModule.forChild(ISSUES_ROUTES)],
    exports: [RouterModule]
})
export class IssuesRoutingModule { }
